import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { Select } from 'formik-mui';
import { makeStyles } from '@mui/styles';
import { InputLabel, FormControl, OutlinedInput } from '@mui/material';

const useStyles = makeStyles(() => ({
  menuPaper: {
    maxHeight: 300,
  },
}));

const MultipleSelectBox = React.memo(
  ({ label, children, options, multiple, size, ...rest }) => {
    const classes = useStyles();

    const outlinedSelectRef = React.createRef();
    const [selectLabelWidth, setSelectLabelWidth] = React.useState(0);

    React.useEffect(() => {
      setSelectLabelWidth(outlinedSelectRef.current.offsetWidth);
    }, [outlinedSelectRef]);

    return (
      <FormControl variant="outlined" fullWidth {...options} size={size}>
        <InputLabel ref={outlinedSelectRef} htmlFor={name}>
          {label}
        </InputLabel>
        <Field
          multiple={multiple}
          component={Select}
          MenuProps={{
            classes: { paper: classes.menuPaper },
            getContentAnchorEl: null,
          }}
          input={<OutlinedInput labelWidth={selectLabelWidth} name={name} />}
          {...rest}>
          {children}
        </Field>
      </FormControl>
    );
  },
);

MultipleSelectBox.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  options: PropTypes.object,
  multiple: PropTypes.bool,
};

MultipleSelectBox.defaultProps = {
  label: 'MultipleSelectBox',
  children: [],
  options: {},
  multiple: true,
};

export default MultipleSelectBox;
